import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr15 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа по антенно-фидерни и мачтови съоръжения
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. При работа по</b> антенно-фидерни и мачтови съоръжения се допускат лица, които:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - притежават необходимата техническа квалификация
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преминали са медицински прегледи;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преминали са обучение /инструктаж/ по безопасни методи на работа и са снабдени с
          удостоверение за самостоятелна работа;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - познават правилата и начините за даване на първа долекарска помощ;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - използват изискваните лични предпазни средства за работа на височина;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - не се допускат лица, които не са здрави или са неразположени през работния ден;
          употребили са опиати или други упойващи средства, или са в нетрезво състояние.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          2. <span style={styles.warning}>Забранява се </span>
        </b>
        работата по антените и в антенното поле по време на буря и активна гръмотевична дейност; при
        поледица; силен дъжд; снеговалеж; мъгла; скорост на вятъра повече от 12m/sec и в тъмната
        част на денонощието. (Ако аварийни обстоятелства налагат да се работи през нощта, работното
        място на служителя и повдигателните машини трябва да бъдат осветени с прожектори без да се
        заслепяват очите на работещите).
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          3. <span>Забранява се </span>
        </b>
        работата на сам служител при работа на височина със стълби или по мачтите при ремонти на
        съоръженията.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Преди започване на работа</b> със стълби предварително се проверява тяхната годност.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          5. <span style={styles.warning}>Забранява се </span>
        </b>
        работата с преносими стълби:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при натягане на проводници, когато има опасност да се преобърне стълбата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - в близост до неоградени тоководещи части под напрежение;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - двама души на единична стълба;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - подхвърлянето на инструменти и дребни части.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Всекидневно, преди работа </b>да се проверява изправността на повдигателните механизми
        /лебедки, въжета, ролки, куки, кошове и др./, личните предпазни средства. Забранено е
        използването на приспособления, които не са подложени на техническо освидетелстване:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преди пускането им в експлоатация;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - ежегодно;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - след ремонт или при съмнения за годност.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Не се допуска използването</b> на повдигателните уредби и приспособления в среда,
        режим, товароподемност и други параметри, различни от посочените в техническата документация
        и паспорта им.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. Всички нетоководещи части</b> на електролебедката трябва да бъдат заземени.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          9. <span style={styles.warning}>Забранява се </span>
        </b>
        издигането и спускането на служител при откачен палец (спусък) на зъбното колело. При
        повдигателните лебедки винаги трябва да има дъска за принудително спиране на лебедката при
        счупване на зъбния механизъм или спирачката.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>10. Лицата, пряко ангажирани </b>с управлението на съоръженията, използвани за издигане и
        спускане на хора и товари, както и техните помощници, трябва да са специално обучени и
        допълнително инструктирани. Забранява се:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - да се отдалечават от повдигателните съоръжения, когато работещия се намира на мачтата;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - при ръчно задвижване на лебедката, да си пускат ръката от ръкохватката по време на
          издигане и спускане на работещия;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - направлението с ръка на въжето, при навиването му на барабана.
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Издигането и спускането на служител </b>трябва да се извършва само по негова команда.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. Работните инструменти</b> и дребните части трябва да се носят от работещия в
        брезентова чанта. Забранява се поставянето на инструменти и други предмети по конструкцията
        на мачтите.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. При използване </b>на преносими електрически уреди /бормашина, електрожен и др./
        задължително се използват изолационни предпазни средства /диелектрични ръкавици и др./
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14. Всички антенно- мачтови и фидерни съоръжения </b>се изпълняват съгласно утвърден
        технически проект, в който е включен и раздел за организация на работата по осигуряване
        безопасността на работниците.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15. Издигането на мачти </b>трябва да се осъществява съгласно технически проект.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>16. Подаването на команди </b>при повдигане и снемане на конструкции или товари се
        извършва само от едно лице.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>17. Преди всяко </b>извършване на работи по антенно -мачтови и фидерни съоръжения,
        определеното със заповед на работодателя лице трябва да провежда инструктажпо безопасността
        на труда с изпълнителите.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          18.
          <span style={styles.title}>Забранява се </span>
        </b>
        извършването на каквато и да е работа по мачтите и антените, които се намират под
        напрежение, с изключение на измервания и настройки.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>19. Работите по настройката </b>и измерванията на антените и фидерните съоръжения се
        извършват най-малко от две лица, едното от които трябва да има квалификация, не по ниска от
        IV група, а другото - не по ниска от III група.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>20. Работещите по ретранслаторни съоръжения </b>да не са по малко от двама и да
        притежават не по ниска от III квалификационна група по безопасност на труда.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>21. Към оперативно обслужване </b>на съоръженията се допускат лица, добре познаващи
        електрическите схеми на съответните съоръжения и особеностите на уредбите.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>22. При всички ремонтни работи</b> да се спазват изискванията от &quot;Правилник за
        безопасност и здраве при работа по електрообзавеждането с напрежение до 1000 V&quot;.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr15;
